<template>
  <div>
    <div v-html="content">

    </div>
  </div>
</template>
<script>
import { report } from "@/api/interview";
export default {
  data(){
    return {
      content: '',
      resume_id: this.$route.query.resume_id,
      indicator: [],
      value: []
    }
  },
  created(){
    this.report()
    this.reportMax()
    // this.report(1)
  },
  mounted(){
    this.$nextTick(() => {
      this.init()
    });
  },
  methods:{
    report(){
      const info = {
        resume_id: this.resume_id
      }
      report(info).then(res=>{
        console.log(res,'res')
        this.content = res.result
        this.$nextTick(()=>{
          var that = this
          var sub_btn = document.getElementsByClassName('sub_btn')[0]
          sub_btn.onclick = function(){
              that.$router.go(-2)
          }
        })
      })
    },
    reportMax(){
      const info = {
        resume_id: this.resume_id,
        report_type: 1
      }
      report(info).then(res=>{
        console.log(res,'res')
        this.indicator = res.result.indicator
        this.value = res.result.value
      })
    },
    init(){
      setTimeout(()=>{
        const option = {
        legend: {
          data: ['Allocated Budget', 'Actual Spending']
        },
        radar: {
          // shape: 'circle',
          radius: '60%',
          splitNumber: 2, // 网格线的个数
          name: {
            textStyle: {
                color: '#333',
                // backgroundColor: '#333',
                // borderRadius: 3,
                // padding: [3, 5]
            }
          },
          splitArea : {
            show : false,
            areaStyle : {
                color: 'rgba(255,0,0,0)', // 图表背景的颜色
            },
          },
          splitLine : {
            show : true,
            lineStyle : {
                width : 1,
                color : '#333', // 设置网格的颜色
            },
          },
            center: ['50%', '50%'],
            indicator: this.indicator
          },
          series: [{
            type: 'radar',
            data : [
              {
                value : this.value,
                areaStyle: {
                  normal: {
                    color: '#FC6141' // 选择区域颜色
                  }
                }
              },
            ]
          }]
        }
        var myChart = this.$echarts.init(document.getElementById('main'));
        myChart.setOption(option);
        //  setTimeout(function (){
        //   window.onresize = function () {
        //     myChart.resize();
        //   }
        // },200)
        // document.body.replaceChild(newMain,oldMain);
      },1000)
      
    }
  }
}
</script>
<style lang="scss" scoped>
#main {
  width: 67%;
  height: 500px;
  margin: 200px auto;
}
</style>